var cov_b21l8ptm2 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/detect.ts",
      hash = "a85203ce2184744963c32c6b2624fed39b7a8f1e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/detect.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 26
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 40
        },
        end: {
          line: 9,
          column: 51
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 18
        }
      },
      "3": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "4": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "5": {
        start: {
          line: 19,
          column: 13
        },
        end: {
          line: 19,
          column: 40
        }
      },
      "6": {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 20,
          column: 25
        }
      },
      "7": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 38
        }
      },
      "8": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      "9": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "10": {
        start: {
          line: 27,
          column: 7
        },
        end: {
          line: 27,
          column: 56
        }
      },
      "11": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 19
        }
      },
      "12": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 74
        }
      },
      "13": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "14": {
        start: {
          line: 32,
          column: 27
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "15": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 71
        }
      },
      "16": {
        start: {
          line: 38,
          column: 22
        },
        end: {
          line: 38,
          column: 27
        }
      },
      "17": {
        start: {
          line: 39,
          column: 0
        },
        end: {
          line: 46,
          column: 14
        }
      },
      "18": {
        start: {
          line: 40,
          column: 15
        },
        end: {
          line: 44,
          column: 4
        }
      },
      "19": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 28
        }
      },
      "20": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 76
        }
      },
      "21": {
        start: {
          line: 49,
          column: 28
        },
        end: {
          line: 49,
          column: 71
        }
      }
    },
    fnMap: {
      "0": {
        name: "getTransformName",
        decl: {
          start: {
            line: 10,
            column: 16
          },
          end: {
            line: 10,
            column: 32
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "has3d",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 21
          }
        },
        loc: {
          start: {
            line: 14,
            column: 24
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 34
          },
          end: {
            line: 25,
            column: 35
          }
        },
        loc: {
          start: {
            line: 25,
            column: 66
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 41
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }, {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 56
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 56
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 8
          }
        }, {
          start: {
            line: 32,
            column: 12
          },
          end: {
            line: 32,
            column: 25
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 34,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 34,
            column: 29
          }
        }, {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 50
          }
        }, {
          start: {
            line: 34,
            column: 54
          },
          end: {
            line: 34,
            column: 71
          }
        }],
        line: 34
      },
      "5": {
        loc: {
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 46
          },
          end: {
            line: 49,
            column: 63
          }
        }, {
          start: {
            line: 49,
            column: 66
          },
          end: {
            line: 49,
            column: 71
          }
        }],
        line: 49
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export var TRANSFORMS = (cov_b21l8ptm2.s[0]++, {
  webkitTransform: '-webkit-transform',
  OTransform: '-o-transform',
  msTransform: '-ms-transform',
  MozTransform: '-moz-transform',
  transform: 'transform'
});
var transform = (cov_b21l8ptm2.s[1]++, 'transform');
export function getTransformName() {
  cov_b21l8ptm2.f[0]++;
  cov_b21l8ptm2.s[2]++;
  return transform;
}
export function has3d() {
  cov_b21l8ptm2.f[1]++;
  cov_b21l8ptm2.s[3]++;

  if (!window.getComputedStyle) {
    cov_b21l8ptm2.b[0][0]++;
    cov_b21l8ptm2.s[4]++;
    return false;
  } else {
    cov_b21l8ptm2.b[0][1]++;
  }

  var el = (cov_b21l8ptm2.s[5]++, document.createElement('p'));
  var result = (cov_b21l8ptm2.s[6]++, ''); // Add it to the body to get the computed style.

  cov_b21l8ptm2.s[7]++;
  document.body.insertBefore(el, null);
  cov_b21l8ptm2.s[8]++;
  Object.keys(TRANSFORMS).forEach(function (t) {
    cov_b21l8ptm2.f[2]++;
    cov_b21l8ptm2.s[9]++;

    if (el.style[t] !== undefined) {
      cov_b21l8ptm2.b[1][0]++;
      ;
      cov_b21l8ptm2.s[10]++;
      el.style[t] = 'translate3d(1px,1px,1px)';
      cov_b21l8ptm2.s[11]++;
      transform = t;
      cov_b21l8ptm2.s[12]++;
      result = window.getComputedStyle(el).getPropertyValue(TRANSFORMS[t]);
    } else {
      cov_b21l8ptm2.b[1][1]++;
    }
  });
  cov_b21l8ptm2.s[13]++;

  if ((cov_b21l8ptm2.b[3][0]++, el) && (cov_b21l8ptm2.b[3][1]++, el.parentNode)) {
    cov_b21l8ptm2.b[2][0]++;
    cov_b21l8ptm2.s[14]++;
    el.parentNode.removeChild(el);
  } else {
    cov_b21l8ptm2.b[2][1]++;
  }

  cov_b21l8ptm2.s[15]++;
  return (cov_b21l8ptm2.b[4][0]++, result !== undefined) && (cov_b21l8ptm2.b[4][1]++, result.length > 0) && (cov_b21l8ptm2.b[4][2]++, result !== 'none');
}
/* eslint-disable */
// check support passive

var supportsPassive = (cov_b21l8ptm2.s[16]++, false);
cov_b21l8ptm2.s[17]++;

try {
  var opts = (cov_b21l8ptm2.s[18]++, Object.defineProperty({}, 'passive', {
    get: function get() {
      cov_b21l8ptm2.f[3]++;
      cov_b21l8ptm2.s[19]++;
      supportsPassive = true;
    }
  }));
  cov_b21l8ptm2.s[20]++;
  window.addEventListener('test', null, opts);
} catch (e) {}
/* eslint-enable */


export var eventPassive = (cov_b21l8ptm2.s[21]++, supportsPassive ? (cov_b21l8ptm2.b[5][0]++, {
  passive: true
}) : (cov_b21l8ptm2.b[5][1]++, false));